import React from "react";
import {Check, X, HelpCircle, ShieldAlert, ThumbsUp, ThumbsDown, CircleOff} from "lucide-react";

const STATUS_ICON = {
    success: <Check size={18} />,
    failed: <X size={18} />,
    uncertain: <HelpCircle size={18} />,
    blocked: <ShieldAlert size={18} />,
    unanalyzed: <CircleOff size={18} />,
}

// Outcome marker: the same colored icon used in the Bot Performance card and the
// session rows, so a session's status reads in the same visual language everywhere.
// `status` is one of success | failed | uncertain | blocked | unanalyzed | feedback;
// for feedback, `feedback` ("positive" | "negative" | null) carries the sentiment.
export default function SessionMarker({status, feedback}) {
    if (status === "feedback") {
        const cls = `session-marker feedback ${feedback || "none"}`
        return <span className={cls}>
            <span className="marker-feedback">
                {feedback === "negative" ? <ThumbsDown size={18} /> : <ThumbsUp size={18} />}
            </span>
        </span>
    }
    return <span className={`session-marker ${status}`}>
        {STATUS_ICON[status] || STATUS_ICON.unanalyzed}
    </span>
}

export {STATUS_ICON}
